<template>
  <v-card>
    <v-card-title primary-title class="justify-center">
      <div>  
        <div class="display-1 font-weight-medium blue--text">
          <v-icon large>description</v-icon>
          Medical Certificate
        </div>
        <center>
          <span class="subheading blue--text">Find</span>
        </center>
      </div>
    </v-card-title>
    <v-card-text>
      <v-flex xs10 offset-xs1>
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex xs10 align-center text-xs-center>
              <v-text-field
                class="mx-3"
                background-color="blue lighten-5"
                outline
                label="Certificate ID"
                v-model.trim="searchCertificateID"
                append-icon="search"
                @click:append="openCertificate"
                @keydown.enter.prevent="openCertificate"
              ></v-text-field>
            </v-flex>
            <v-flex xs2 align-center text-xs-center>
              <img src="~assets/images/scan_qrcode.png" class="cursor" @click="scanQrcode">
            </v-flex>
            <v-flex xs12 align-center text-xs-center>
              <p class="error">{{ error }}</p>
            </v-flex>
          </v-layout>    
        </v-container>  
      </v-flex>
    </v-card-text>
    <v-dialog v-model="certificateDialog" width="600px">
      <span id="certificate">
        <v-card class="modal-detail">
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout row wrap align-center text-xs-center>
                <v-flex xs6>
                  <img src="~assets/images/logo_althash_health_top.png" class="logo1">
                </v-flex>
                <v-flex xs6>
                  <img src="~assets/images/logo_althash.png" class="logo2">
                </v-flex>
                <v-flex xs12>
                  <span class="font-weight-bold my-2 headline" id="title">
                    Medical Certificate
                  </span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <p>
                    <b>{{ this.date }}</b>
                  </p>
                  <p>
                    To whom it may concern,
                  </p>
                  <p>
                    This is to certify that <b>{{ this.fullName }}</b>, {{ this.patientAge }} years old, {{ this.gender }}, resident of {{ this.address }}, was seen and examined/treated on {{ this.certDate }} at <b>{{ this.certFacilityName }}</b> with the following diagnosis:
                    <br><br>
                    <b>{{ this.certDiagnosis }}</b>
                    <br><br>
                    <b>Recommendation:</b> {{ this.certRecommendation }}
                    <br>
                    <b>Number of days of rest:</b> {{ this.certDaysOfRest }}
                    <br><br>
                    <b>{{ this.certPhysicianName }}</b>
                    <br>
                    PRC: {{ this.certPhysicianPRC }}
                  </p>
                  <p class="text-xs-center">
                    <img :src="qr" class="qr" id="qr"/>
                    <br>
                    <span class="caption" id="certificate_id">Certificate ID: {{ this.searchCertificateID }}</span>
                    <br>
                    <v-btn icon @click="print" id="btn">
                      <v-icon>print</v-icon>
                    </v-btn>
                  </p>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </span>
    </v-dialog>
    <v-dialog v-model="qrScan" max-width="50%">
      <v-container>
        <v-layout>
          <v-flex xs12 align-center text-xs-center>
            <qrcode-stream :track="false" @decode="onDecode" @init="onInit" :camera="camera" v-if="qrComponent" />
          </v-flex>
        </v-layout>    
      </v-container>
    </v-dialog>
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style scoped>
  .error {
    font-weight: bold;
    color: red;
  }

  .cursor:hover {
    cursor: pointer;
  }

  .modal-detail {
    background-image: url("~assets/images/myoffspring_border.png");
  }

  .logo1 {
    width: auto; 
    height: 40px;
  }

  .logo2 {
    width: auto; 
    height: 40px;
  }

  .qr {
    width: 75px; 
    height: auto;
  }
</style>

<script>
  import webWallet from 'libs/web-wallet'
  import abi from 'ethjs-abi'
  import server from 'libs/server'
  import qrcode from 'qrcode'
  import { QrcodeStream, QrcodeCapture } from 'vue-qrcode-reader'
  import printd from 'printd'
  import base58 from 'bs58'
  import config from 'libs/config'

  const certificateContractAddress = config.getNetwork() == "mainnet" ? "e6bd657ecb870c192799469ca3e4c9d507dffe85" : "0";

  const certificateAbiJson = JSON.parse(
    '[{"constant": true, "inputs": [], "name": "AHPatientContractAddress", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_patientID", "type": "string"}, {"name": "_page", "type": "uint256"} ], "name": "getPatientCertificates", "outputs": [{"name": "certificate1", "type": "string"}, {"name": "certificate1Date", "type": "uint256"}, {"name": "certificate2", "type": "string"}, {"name": "certificate2Date", "type": "uint256"}, {"name": "certificate3", "type": "string"}, {"name": "certificate3Date", "type": "uint256"}, {"name": "certificate4", "type": "string"}, {"name": "certificate4Date", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_certificateID", "type": "string"}, {"name": "_patientID", "type": "string"}, {"name": "_physicianUserAddress", "type": "address"}, {"name": "_facilityUserAddress", "type": "address"}, {"name": "_certificateDate", "type": "uint256"}, {"name": "_certificateDiagnosis", "type": "string"}, {"name": "_certificateRecommendation", "type": "string"}, {"name": "_numberOfDaysOfRest", "type": "uint8"} ], "name": "setCertificateDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_patientID", "type": "string"} ], "name": "getPatientCertificatesTotal", "outputs": [{"name": "", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_newAddress", "type": "address"} ], "name": "setAHPatientContractAddress", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_patientID", "type": "string"} ], "name": "getPatientCertificatesPages", "outputs": [{"name": "pages", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_newAddress", "type": "address"} ], "name": "setAHUserContractAddress", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [], "name": "AHUserContractAddress", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_newOwner", "type": "address"} ], "name": "ownershipTransfer", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [{"name": "_certificateID", "type": "string"}, {"name": "_patientID", "type": "string"} ], "name": "invalidateCertificate", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_certificateID", "type": "string"} ], "name": "getCertificateDetails", "outputs": [{"name": "patientID", "type": "string"}, {"name": "physicianUserAddress", "type": "address"}, {"name": "facilityUserAddress", "type": "address"}, {"name": "certificateDate", "type": "uint256"}, {"name": "certificateDiagnosis", "type": "string"}, {"name": "certificateRecommendation", "type": "string"}, {"name": "numberOfDaysOfRest", "type": "uint8"}, {"name": "updatedBy", "type": "address"}, {"name": "used", "type": "bool"}, {"name": "valid", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [], "name": "ownershipTransferConfirm", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor"} ]'
  );

  const patientContractAddress = config.getNetwork() == "mainnet" ? "07ba64f3210d351da06958405231b10ccb2fdc56" : "0";

  const patientAbiJson = JSON.parse(
    '[{"constant": false, "inputs": [{"name": "_patientID", "type": "string"}, {"name": "_patientFullName", "type": "string"}, {"name": "_patientDateOfBirth", "type": "uint256"}, {"name": "_myOffspringID", "type": "string"}, {"name": "_patientGender", "type": "uint8"}, {"name": "_patientEmail", "type": "string"}, {"name": "_patientAddress", "type": "string"}, {"name": "_patientPhone", "type": "uint256"} ], "name": "setPatientDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [], "name": "potentialOwner", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [], "name": "owner", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_patientID", "type": "string"} ], "name": "isPatientValid", "outputs": [{"name": "", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_newAddress", "type": "address"} ], "name": "setAHUserContractAddress", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [{"name": "_patientID", "type": "string"} ], "name": "invalidatePatient", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [], "name": "myOffspringContractAddress", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [], "name": "AHUserContractAddress", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "newOwner", "type": "address"} ], "name": "ownershipTransfer", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_patientID", "type": "string"} ], "name": "getPatientDetails", "outputs": [{"name": "patientFullName", "type": "string"}, {"name": "patientDateOfBirth", "type": "uint256"}, {"name": "myOffspringID", "type": "string"}, {"name": "patientGender", "type": "uint256"}, {"name": "patientEmail", "type": "string"}, {"name": "patientAddress", "type": "string"}, {"name": "patientPhone", "type": "uint256"}, {"name": "updatedBy", "type": "address"}, {"name": "valid", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [], "name": "ownershipTransferConfirm", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor"} ]'
  );

  const userContractAddress = config.getNetwork() == "mainnet" ? "1184387fabba8058e3094dbb489be214dba4b770" : "0";

  const userAbiJson = JSON.parse(
    '[{"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_userType", "type": "uint8"}, {"name": "_userFullName", "type": "string"}, {"name": "_userEmail", "type": "string"}, {"name": "_userPhysicalAddress", "type": "string"}, {"name": "_userPhone", "type": "uint256"}, {"name": "_facilityType", "type": "uint8"}, {"name": "_userAccessLevel", "type": "uint8"} ], "name": "setUserFacilityDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [{"name": "_newLimit", "type": "uint8"} ], "name": "setFacilitiesLimit", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_physicianUserAddress", "type": "address"} ], "name": "getPhysicianFacilitiesTotal", "outputs": [{"name": "", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "invalidateUser", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "checkPhysician", "outputs": [{"name": "isPhysician", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [], "name": "getFacilitiesLimit", "outputs": [{"name": "", "type": "uint8"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_physicianUserAddress", "type": "address"}, {"name": "_facilityUserAddress", "type": "address"} ], "name": "addPhysicianToFacility", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [{"name": "_physicianUserAddress", "type": "address"}, {"name": "_facilityUserAddress", "type": "address"} ], "name": "removePhysicianfromFacility", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "isUserValid", "outputs": [{"name": "", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_userType", "type": "uint8"}, {"name": "_userFullName", "type": "string"}, {"name": "_userEmail", "type": "string"}, {"name": "_userPhysicalAddress", "type": "string"}, {"name": "_userPhone", "type": "uint256"}, {"name": "_userAccessLevel", "type": "uint8"} ], "name": "setUserDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "", "type": "address"} ], "name": "usersAccessLevels", "outputs": [{"name": "", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "checkFacility", "outputs": [{"name": "isFacility", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserFacilityType", "outputs": [{"name": "", "type": "uint8"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "activateUser", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_physicianUserAddress", "type": "address"} ], "name": "getPhysicianFacilities", "outputs": [{"name": "facility1", "type": "address"}, {"name": "facility1Name", "type": "string"}, {"name": "facility2", "type": "address"}, {"name": "facility2Name", "type": "string"}, {"name": "facility3", "type": "address"}, {"name": "facility3Name", "type": "string"}, {"name": "facility4", "type": "address"}, {"name": "facility4Name", "type": "string"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_userType", "type": "uint8"}, {"name": "_userFullName", "type": "string"}, {"name": "_userEmail", "type": "string"}, {"name": "_userPhysicalAddress", "type": "string"}, {"name": "_userPhone", "type": "uint256"}, {"name": "_PRC", "type": "uint256"}, {"name": "_PRCExpDate", "type": "uint256"}, {"name": "_PTR", "type": "uint256"}, {"name": "_PTRExpDate", "type": "uint256"}, {"name": "_S2", "type": "uint256"}, {"name": "_S2ExpDate", "type": "uint256"}, {"name": "_userAccessLevel", "type": "uint8"} ], "name": "setUserPhysicianDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserPhysicianDetails", "outputs": [{"name": "PRC", "type": "uint256"}, {"name": "PRCExpDate", "type": "uint256"}, {"name": "PTR", "type": "uint256"}, {"name": "PTRExpDate", "type": "uint256"}, {"name": "S2", "type": "uint256"}, {"name": "S2ExpDate", "type": "uint256"}, {"name": "updatedBy", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserDetails", "outputs": [{"name": "userType", "type": "uint8"}, {"name": "userFullName", "type": "string"}, {"name": "userEmail", "type": "string"}, {"name": "userPhysicalAddress", "type": "string"}, {"name": "userPhone", "type": "uint256"}, {"name": "updatedBy", "type": "address"}, {"name": "valid", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_newOwner", "type": "address"} ], "name": "ownershipTransfer", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [], "name": "totalDataInput", "outputs": [{"name": "", "type": "uint16"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [], "name": "totalAdmins", "outputs": [{"name": "", "type": "uint16"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserAccessLevel", "outputs": [{"name": "", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_accessLevel", "type": "uint8"} ], "name": "setUserAccessLevel", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [], "name": "ownershipTransferConfirm", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor"} ]'
  );

  export default {
    data () {
      return {
        loading: false,
        date: new Date().toISOString().substr(0, 10),
        menu_date: false,
        searchCertificateID: '',
        patientID: '',
        fullName: '',
        patientAge: '',
        gender: '',
        address: '',
        certDate: '',
        certFacilityName: '',
        certDiagnosis: '',
        certRecommendation: '',
        certDaysOfRest: '1',
        certPhysicianName: '',
        certPhysicianPRC:'',
        error: null,
        qrScan: false,
        camera: false,
        qrComponent: false,
        fullName: '',
        dateOfBirth: '',
        gasPrice: '40',
        gasLimit: '2500000',
        fee: '0.01',
        confirmSendDialog: false,
        execResultDialog: false,
        rawTx: 'loading...',
        canSend: false,
        sending: false,        
        qr: ''
      }
    },
    components:{
      QrcodeStream,
      QrcodeCapture
    },
    watch: {
      method: function() {
        this.inputParams = []
      },
      qrScan(val){
        if(!val)
          this.camera = false
      }
    },
    methods: {
      print(){
        const cssText = `
          #title {
            font-family: Arial, Helvetica, sans-serif;
            font-weight: bold;
            font-size: x-large;
            text-align: center;                      
            display: block;
            padding: 20px;
            margin-top: 120px;
          }

          p {
            font-family: Arial, Helvetica, sans-serif;
            margin-left: 50px;
            margin-right: 50px;
          }

          img {
                display: block;
                margin-left: auto;
                margin-right: auto;
                width: auto; 
                height: 40px;
                padding: 10px;
              }

          #certificate_id {
            font-family: Arial, Helvetica, sans-serif;
            text-align: center;
            display: block;
            padding: 20px;
          }

          .logo1 {
            float: left;
            padding: 10px;
            height: 20px;
            width: auto;
            margin-left: 25px;
          }

          .logo2 {
            float: right;
            padding: 10px;
            height: 20px;
            width: auto;
            margin-right: 25px;
          }

          #qr {
            margin-left: auto;
            margin-right: auto;
            padding: 10px;
            width: 150px; 
            height: auto;
            display: block;
          }

          #btn {
            display: none;
          }
        `;

        const d = new printd();
        const printCallback = ({ launchPrint }) => launchPrint();
        d.print( document.getElementById('certificate'), cssText, printCallback );
      },

      scanQrcode(){
        this.searchCertificateID = '';
        this.qrComponent = true;
        this.camera = true;
        this.qrScan = true;
      },

      onDecode(certificateID) {
        this.searchCertificateID = certificateID
        this.camera = false;
        this.qrScan = false;
        this.openCertificate();
      },

      async onInit (promise) {
        try {
          await promise
        } catch (error) {
          if (error.name === 'NotAllowedError') {
            this.error = "ERROR: you need to grant camera access permisson"
          } else if (error.name === 'NotFoundError') {
            this.error = "ERROR: no camera on this device"
          } else if (error.name === 'NotSupportedError') {
            this.error = "ERROR: secure context required (HTTPS, localhost)"
          } else if (error.name === 'NotReadableError') {
            this.error = "ERROR: is the camera already in use?"
          } else if (error.name === 'OverconstrainedError') {
            this.error = "ERROR: installed cameras are not suitable"
          } else if (error.name === 'StreamApiNotSupportedError') {
            this.error = "ERROR: Stream API is not supported in this browser"
          }
        }
      },

      async openCertificate(){
        if(this.searchCertificateID != '') {
          this.loading = true;
          try{
            var decodedResult = await this.callContractFunction(
              certificateContractAddress, 
              certificateAbiJson, 
              'getCertificateDetails', 
              [this.searchCertificateID]
            );

            if(decodedResult[9].toString() != 'true'){
              this.loading = false;
              alert('The certificate ID informed is invalid.')
            } else {

              this.certDate = decodedResult[3].toString();
              this.certDate = this.certDate.substring(0,4)+"-"+this.certDate.substring(4,6)+"-"+this.certDate.substring(6);

              this.patientID = decodedResult[0].toString();
              this.certPhysicianAddress = decodedResult[1].toString();
              this.certFacilityAddress = decodedResult[2].toString();
              this.certDiagnosis = decodedResult[4].toString();
              this.certRecommendation = decodedResult[5].toString();
              this.certDaysOfRest = decodedResult[6].toString();

              // Get Health Facility Name
              decodedResult = await this.callContractFunction(
                userContractAddress, 
                userAbiJson, 
                'getUserDetails', 
                [this.certFacilityAddress]
              );

              this.certFacilityName = decodedResult[1].toString();

              // Get Physician Name
              decodedResult = await this.callContractFunction(
                userContractAddress, 
                userAbiJson, 
                'getUserDetails', 
                [this.certPhysicianAddress]
              );

              this.certPhysicianName = decodedResult[1].toString();

              // Get Physician PRC
              decodedResult = await this.callContractFunction(
                userContractAddress, 
                userAbiJson, 
                'getUserPhysicianDetails', 
                [this.certPhysicianAddress]
              );

              this.certPhysicianPRC = decodedResult[0].toString(); 

              //Gets Patient's details
              decodedResult = await this.callContractFunction(
                patientContractAddress, 
                patientAbiJson, 
                'getPatientDetails', 
                [this.patientID]
              );

              this.fullName = decodedResult[0].toString();
              this.address = decodedResult[5].toString();
              this.dateOfBirth = decodedResult[1].toString().substring(0,4)
                                +"-"+
                                decodedResult[1].toString().substring(4,6)
                                +"-"+
                                decodedResult[1].toString().substring(6);

              // Get patient age
              this.patientAge = this.getAge(this.dateOfBirth);

              switch(parseInt(decodedResult[3])){
                case 0:
                  this.gender = 'Unknown';
                  break;
                case 1:
                  this.gender = 'Male';
                  break;
                case 2:
                  this.gender = 'Female';
                  break;
                case 3:
                  this.gender = 'Other';
                  break;
                default:
                  this.gender = 'Unknown';
              }

              this.loading = false;
              this.certificateDialog = true;
              this.drawQrCode();
            }

          } catch (e) {
              this.loading = false;
              this.$root.log.error('call_contract_call_contract_error', e.stack || e.toString() || e);
              alert(e.message || e);
              this.execResultDialog = false;
          }
        }
      },

      findIndexByName(abiJson, name){
        return abiJson.findIndex(function(item){
          return item.name === name
        });
      },

      async callContractFunction(contractAddress, abiJson, functionName, params){
        const encodedData = abi.encodeMethod(
          abiJson[
            this.findIndexByName(
              abiJson,
              functionName
            )
          ], 
          params
        ).substr(2);
        var encodedResult = await webWallet.getWallet().callContract(contractAddress, encodedData);          
        encodedResult = '0x' + encodedResult;

        return abi.decodeMethod(abiJson[this.findIndexByName(abiJson,functionName)], encodedResult);
      },

      encodeContractSendFunction(abiJson, functionName, params){
        return abi.encodeMethod(
          abiJson[this.findIndexByName(abiJson, functionName)], 
          params
        ).substr(2);
      },

      getAge(dateString) {
          var today = new Date();
          var birthDate = new Date(dateString);
          var age = today.getFullYear() - birthDate.getFullYear();
          var m = today.getMonth() - birthDate.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
              age--;
          }
          return age;
      },

      drawQrCode() {
        qrcode.toDataURL(this.searchCertificateID, (err, url) => {
          this.qr = url
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/controllers/Certstandard-Read.vue